import toast from "react-hot-toast";
import { getSessionToken } from "../Config/common.config";
import { getPostUrl } from "./helpers";

export const fetchProtectedObjectURL = async (src: string): Promise<string> => {
  if (!src) {
    console.error("fetchProtectedObjectURL called with invalid src");
    throw new Error("Source URL is missing.");
  }

  const token = getSessionToken();
  const fullUrl = getPostUrl(src);

  const response = await fetch(fullUrl, {
    headers: { Authorization: `Bearer ${token}` },
    mode: "cors",
  });

  if (!response.ok) throw new Error(response.statusText);

  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

// export const fetchProtectedObjectURL = async (
//   src: string
// ): Promise<string> => {
//   const token = getSessionToken();
//   if (!src) {
//     throw new Error("Source URL is missing.");
//   }

//   const response = await fetch(getImageUrl(src), {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (!response.ok) {
//     throw new Error(`Failed to fetch protected media: ${response.statusText}`);
//   }
//   const blob = await response.blob();
//   return URL.createObjectURL(blob);
// };

export const Capitalize = (word: string | undefined): string =>
  `${word ? `${word[0].toUpperCase()}${word.slice(1)}` : ""}`;

export const normalizeCreatorUsername = (username: string | undefined): string => {
  const rawUsername = String(username ?? "").trim();

  if (!rawUsername) return "";

  try {
    return decodeURIComponent(rawUsername).replace(/^@+/, "").trim();
  } catch {
    return rawUsername.replace(/^@+/, "").trim();
  }
};

export const getCreatorProfilePath = (username: string | undefined): string => {
  const normalizedUsername = normalizeCreatorUsername(username);
  return normalizedUsername ? `/@${normalizedUsername}` : "/";
};

export const copyUserProfileLink = (username: string) => {
  const link = `${window.location.origin}${getCreatorProfilePath(username)}`;
  navigator.clipboard
    .writeText(link)
    .then(() => {
      toast.success("Profile Link Copied");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};

export const messageScrollHandler = () => {
  setTimeout(() => {
    var message_container = document.getElementById("message-container");
    if (message_container)
      message_container.scrollTop = message_container.scrollHeight;
  }, 100);
};

export const formatIndianNumber = (amount: number) => {
  let [integerPart, decimalPart] = amount.toString().split(".");

  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits) {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedIntegerPart =
    otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThreeDigits;

  return decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;
};
